/** Informations légales & contact ProMeetService */
export const CONTACT_EMAIL = "nader@promeetservice.fr";
/** Affichage : 06 99 31 53 87 — lien tel: +33699315387 */
export const CONTACT_PHONE = "06 99 31 53 87";
export const CONTACT_PHONE_TEL = "+33699315387";

export const COMPANY = {
  name: "ProMeetService",
  legalForm: "Société par actions simplifiée (SAS)",
  siren: "940 556 491",
  siret: "940 556 491 00014",
  tva: "FR13940556491",
  address: "60 rue François Ier, 75008 Paris",
  director: "Nader HAMDY HASSANEIN",
  email: CONTACT_EMAIL,
  phone: CONTACT_PHONE,
  phoneTel: CONTACT_PHONE_TEL,
  dpoEmail: CONTACT_EMAIL,
  hostName: "OVH",
  hostAddress: "2 rue Kellermann, 59100 Roubaix, France",
  hostPhone: "+33 9 72 10 10 07",
};

export const SOCIAL = {
  instagram: "https://www.instagram.com/promeetservice",
  linkedin: "https://www.linkedin.com/company/promeetservice",
};
